import { Injectable } from "@angular/core";
@Injectable()
export class ContratoValidate {

    cpf_cnpj = '';
    DECIMAL_SEPARATOR=".";
    GROUP_SEPARATOR=",";
    pureResult: any;
    maskedId: any;
    val: any;
    v: any;

    public define(field:string, value:string){
        let r: any;
        switch(field){
            case "cpf_cnpj_titular":
                r = this.formatCpfCnpj(value);
                break;
            case "nomeTitular":
                r = this.formatNomeTitular(value);
                break;    
        }
        return r;
    }
    
    public formatCpfCnpj(valString) {
      if (!valString) {
          return '';
      }
      let val = valString.toString();
      const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
      this.pureResult = parts;
      if(parts[0].length <= 11){
        this.maskedId = this.cpf_mask(parts[0]);
        return this.maskedId;
      }else{
        this.maskedId = this.cnpj(parts[0]);
        return this.maskedId;
      }
    };

    public formatNomeTitular(valor){
        return valor.toUpperCase();
    }
  
  private unFormat(val) {
      if (!val) {
          return '';
      }
      val = val.replace(/\D/g, '');
  
      if (this.GROUP_SEPARATOR === ',') {
          return val.replace(/,/g, '');
      } else {
          return val.replace(/\./g, '');
      }
  };
  
   cpf_mask(v) {
      v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
      v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
      return v;
  }
  
   cnpj(v) {
      v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
      v = v.replace(/^(\d{2})(\d)/, '$1.$2'); //Coloca ponto entre o segundo e o terceiro dígitos
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); //Coloca ponto entre o quinto e o sexto dígitos
      v = v.replace(/\.(\d{3})(\d)/, '.$1/$2'); //Coloca uma barra entre o oitavo e o nono dígitos
      v = v.replace(/(\d{4})(\d)/, '$1-$2'); //Coloca um hífen depois do bloco de quatro dígitos
      return v;
  }

}


// WEBPACK FOOTER //
// ./src/pages/contratos/contratos.validate.ts